import { useCallback, useEffect, useState } from "react";
import { client } from "../lib/axiosClient";
import Cookies from 'universal-cookie';

const cookies = new Cookies(null, { path: '/' });

interface _Props {
    status?: string;
    version?: string;
    referralCode?: string;
    confirmedID?: string;
    accounting?: boolean;
}

export const useClients = ({status, version, referralCode, confirmedID, accounting}: _Props) => {
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<any>(null);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            let params: any = {status}
            if (version && version !== "") {
                params = {...params, version}
            }
            if (referralCode && referralCode !== "") {
                params = {...params, referralCode}
            }
            if (confirmedID && confirmedID !== "") {
                params = {...params, confirmedID}
            }
            if (accounting !== undefined && accounting !== null) {
                params = {...params, accounting}
            }

            const response = await client.get(`/clients`, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': cookies.get('token') || ""
                },
                params: params
            });
            
            if (response.status !== 200) {
                throw new Error('Failed to fetch data');
            }
            setData(response?.data)
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    }, [status, version]);
    
    useEffect(() => {
        fetchData();
    }, [fetchData]);
    
    const refetch = useCallback(() => {
        fetchData();
    }, [fetchData]);

      
    return { data, loading, error, refetch };
}